import Login from "./components/Login/login";
import Register from "./components/Register/register";
import Navbar from "./components/NavBar/navbar";
import Home from "./components/Home/home";
import "antd/dist/antd.css";

function App() {
  return (
    <Login/>
  );
}

export default App;
